import RelatedDetail from '../_detail';

// 関連サイト詳細(JA)。本文・画像は src/data/related/queens-butler.ts、FAQ は src/data/faq.json(/related/queens-butler)。
export default function RelatedQueensButlerPage() {
  return <RelatedDetail slug="queens-butler" lang="ja" />;
}
